import React from 'react';
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router';

import {title} from 'lib/head';

import CenteredPage from 'client/Layout/CenteredPage';
import LogInForm from 'client/LogIn/LogInForm.react';
import {redirect} from 'client/User/UserRedirectUtil';

function LogInPage() {
  return (
    <>
      <Helmet>{title('Log In | Albert')}</Helmet>
      <CenteredPage>
        <LogInForm
          onAuthentication={() => {
            redirect();
          }}
        />
      </CenteredPage>
    </>
  );
}

export default withRouter(LogInPage);
